import moment from "moment";
import { useMemo } from "react";
import { Button, Popover } from "antd";
import { useTranslation } from "react-i18next";
import { CustomIcon, FormPopover } from "datastake-daf/dist/components";

export default function Comments({
  name,
  config = {},
  allData = {},
}) {
  const { t } = useTranslation();
  const dataSource = useMemo(() => {
    return [
      {
        _date: allData.updatedAt,
        comment: ((allData?.meta?.inputs || {})[name] || {}).comment,
      },
    ]
  }, [allData, name]);

  const disabled = !config?.meta?.comment || !dataSource.filter((d) => !!d.comment).length;

  const renderRow = (data, index) => (
    <div key={`${name}-${index}`} className="popover-row">
      <p>{data.comment}</p>
      <div className="info-cont flex">
        <div className="item flex">
          <div className="flex flex-column justify-content-center mr-1">
            <CustomIcon name="Calendar" width={13} height={13} />
          </div>
          <div className="flex flex-column justify-content-center mt-1">
            <label>{moment(data._date).format('DD MMM YYYY')}</label>
          </div>
        </div>
      </div>
    </div>
  );;

  const renderContent = () => (
    <FormPopover
      title={t('Comments')}
      renderContent={() => dataSource.map(renderRow)}
    />
  );

  return disabled ? (
    <Button
      disabled
      className="default p-0 flex flex-column justify-content-center" type="link">
      <CustomIcon name="Comment" width={16} height={16} />
    </Button>
  ) : (
    <Popover content={renderContent()}>
      <Button className="default p-0 flex flex-column justify-content-center" type="link">
        <CustomIcon name="Comment" width={16} height={16} />
      </Button>
    </Popover>
  );
}

